import { render, staticRenderFns } from "./MethodApplicability.vue?vue&type=template&id=389986f0&scoped=true"
import script from "./MethodApplicability.vue?vue&type=script&lang=ts"
export * from "./MethodApplicability.vue?vue&type=script&lang=ts"
import style0 from "./MethodApplicability.vue?vue&type=style&index=0&id=389986f0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389986f0",
  null
  
)

export default component.exports